'use strict'

module.exports = br

function br(h, node) {
  return h(node, 'break')
}
